<template>
    <div class="card-body">
        <div class="row">
            <b-col cols="12" class="justify-content-between d-flex mb-3">
                <h3>Venta de parcelas</h3>
                <b-button @click="$emit('continuar', false)">Continuar sin parcelas</b-button>
            </b-col>
            <b-col cols="12">
                <Stepper
                    ref="stepper"
                    :steps="steps" 
                >
                    <template #pasoZona="{ changeStep }">
                        <VentaPasoUno 
                            @terminado="zonaSeleccionada => { zona = zonaSeleccionada; changeStep(); }" 
                        />  
                    </template>
                    <template #pasoParcelas="{ changeStep }">
                        <VentaPasoDos 
                            ref="VentaPasoDos" 
                            :zona="zona" 
                            @terminado="(datos, cart_id) => { 
                                $emit('continuar', cart_id, datos); 
                            }" 
                            @cambiarZona="() => { zona = null; changeStep(true); }" 
                        />
                    </template>
                </Stepper>
            </b-col>         
        </div>
    </div>
</template>

<script>
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import VentaPasoUno from '@/components/backend/parcelas/VentaPasoUno';
    import VentaPasoDos from '@/components/backend/parcelas/VentaPasoDos';

    export default {
        data() {
            return {
                zona: null
            };
        },
        components: {
            Stepper,
            VentaPasoUno,
            VentaPasoDos
        },
        computed: {
            steps() {
                return [
                    { label: this.$t('parcelas.selecciona_region'), slot: 'pasoZona' },
                    { label: this.$t('parcelas.selecciona_parcelas'), slot: 'pasoParcelas' },
                ]
            }
        }
    }
</script>